import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Breadcrumb from "../components/Breadcrumb";
import { Outlet } from "react-router-dom";

export default function AppLayout() {
  return (
    <div className="h-screen flex bg-gray-100 overflow-hidden">

      {/* SIDEBAR (hidden on mobile) */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* MAIN AREA */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden">

        {/* NAVBAR */}
        <Navbar />

        {/* BREADCRUMB (ONLY DESKTOP) */}
        <div className="hidden md:block px-6 pt-2 shrink-0">
          <Breadcrumb />
        </div>

        {/* CONTENT */}
        <div className="flex-1 overflow-y-auto px-3 md:px-6 pb-6">
          <Outlet />
        </div>

      </div>
    </div>
  );
}